// extracted by mini-css-extract-plugin
export default {"instruction":"kk4MWvoPsitpFAQ7bUX7"};